import React, { useState, useEffect } from 'react';
import '../WidgetEditTypes/TopWidgetEdit.css';
import ImageSizeSlider from '../ImageSizeSlider';

function ImageUploadSection({ 
    label, 
    fieldName, 
    currentImage, 
    onUpload, 
    isUploading, 
    setIsUploading,
    showSizeSlider = false,
    sizeValue,
    onSizeChange,
    sizeMin = 0,
    sizeMax = 100,
    sizeLabel = "Size",
    showToggle = false,
    toggleLabel,
    toggleFieldName,
    toggleChecked,
    onToggleChange
}) {
    const [imagePreview, setImagePreview] = useState(currentImage || '');

    useEffect(() => {
        setImagePreview(currentImage || '');
    }, [currentImage]);

    const handleImageUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            onUpload(file, fieldName, setImagePreview, setIsUploading);
        }
    };

    const uploadId = `${fieldName}Upload`;

    return (
        <div>
            {/* Standard Image Upload - EXAKT wie in bestehenden Komponenten */}
            <div className="widget_upload">
                <div className="upload-label-row">
                    <label>{label}</label>
                    {showToggle && (
                        <button 
                            type="button"
                            className={`pages-edit-toggle ${toggleChecked ? 'pages-edit-toggle-active' : ''}`}
                            onClick={() => onToggleChange({ 
                                target: { 
                                    name: toggleFieldName, 
                                    value: !toggleChecked, 
                                    type: 'checkbox', 
                                    checked: !toggleChecked 
                                } 
                            })}
                            role="switch"
                            aria-checked={toggleChecked}
                            title={toggleLabel}
                        >
                            <span className="pages-edit-toggle-knob"></span>
                        </button>
                    )}
                </div>
                <label className="custom-upload-box" htmlFor={uploadId}>
                    <input 
                        id={uploadId}
                        type="file"
                        accept="image/*"
                        onChange={handleImageUpload}
                        style={{ display: 'none' }}
                    />

                    {isUploading ? (
                        <div className="spinner-container">
                            <div className="spinner-circle"></div>
                            <p>Uploading...</p>
                        </div>
                    ) : imagePreview ? (
                        <img className="uploaded-image-preview" src={imagePreview} alt="Vorschau" />
                    ) : (
                        <div className="upload-image-preview">
                            <img src="/img/upload1.svg" alt="Upload Icon" />
                            <span>Click here to upload your image</span>
                        </div>
                    )}
                </label>
            </div>

            {/* Optional Size Slider */}
            {showSizeSlider && sizeValue !== undefined && onSizeChange && (
                <ImageSizeSlider
                    min={sizeMin}
                    max={sizeMax}
                    label={sizeLabel}
                    width={sizeValue}
                    setWidth={onSizeChange}
                />
            )}
        </div>
    );
}

export default ImageUploadSection;
